import { css } from "emotion";

export const passwordResetPage = css`
  height: 95%;
`;

export const logo = css`
  width: 8.5em !important;
  padding-bottom: 1em;
`;

export const passwordResetBox = css`
  padding-top: 20px;
`;



// WEBPACK FOOTER //
// ./src/routes/public/PasswordReset/styles.js